import type { IGlobalTab } from '@carboncopyco/types/desktop';
import { useLayoutEffect, useState } from 'react';
import { useTabs } from '../store/context';

export function useTabFocus({
  tab,
  onTabIsActivated,
  onTabIsDeactivated,
}: {
  tab: IGlobalTab;
  onTabIsActivated?: () => void;
  onTabIsDeactivated?: () => void;
}) {
  const { activeGlobalTabId } = useTabs();
  const [focusTab] = useState<IGlobalTab>(tab);
  useLayoutEffect(() => {
    if (activeGlobalTabId !== focusTab.id) onTabIsDeactivated?.();
    else {
      onTabIsActivated?.();
    }
  }, [activeGlobalTabId]);
}
